import React, { useState, useMemo, useEffect } from "react";
import { TiTick } from "react-icons/ti";
import Select from "react-select";

export interface ISearchDropDownProps {
  name: string;
  label?: string;
  onChange?: (selectedOptions: any) => void;
  values?: any;
  errors?: any;
  touches?: any;
  onBlur?: any;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  options?: { label: string; value: any }[]; // Define your option type
  multiSelect?: boolean; // New prop to enable/disable multi-selection
  defaultValue?: { label: string; value: any }[];
  remove?: any;
  hidden?: any;
  autoFocus?: any;
  onKeyDown?: any;
  min?: any;
  pattern?: any;
  // type?: any;
  required?: any;
}

const SearchDropDown = (props: ISearchDropDownProps) => {
  const isInvalid = useMemo(() => {
    return props?.touches[props?.name] && props?.errors[props?.name];
  }, [props?.touches, props?.errors, props?.name]);

  const handleChange = (selectedOption: any) => {
    // Custom onChange for Formik compatibility
    if (props.onChange) {
      props.onChange({
        target: {
          name: props.name,
          value: selectedOption?.value ?? null, // Update with selected value
        },
      });
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2">
      <label
        htmlFor={props.name}
        className={` font-Poppins text-[14px] text-[#1A1A1A] ${
          props?.hidden && "hidden"
        }`}
      >
        {props.label}
      </label>

      <Select
        className={
          props?.className
            ? props?.className
            : "w-full focus:outline-none  h-fit text-xs border-[#1718175C] rounded-md "
        }
        id={props?.name}
        placeholder={props.placeholder}
        name={props?.name}
        onChange={handleChange}
        autoFocus={props?.autoFocus}
        onBlur={props?.onBlur}
        // type={props?.type}
        value={props?.options?.find(
          (option) => option.value === props?.values[props?.name]
        )}
        onKeyDown={props?.onKeyDown}
        defaultValue={props?.defaultValue}
        options={props?.options}
        // min={props?.min}
        // pattern={props?.pattern}
      />

      {isInvalid ? (
        <p className="text-red-500 font-[600] text-[10px]">
          {props?.errors[props?.name]}
        </p>
      ) : null}
    </div>
  );
};

export default SearchDropDown;
